<div class="heading">
  <p class="jee">JEE-MAINS SESSION2 ROOKIE HALL TICKET DETAILS</p>
</div>
<div #pageContainer id="pageContainer">
    <table class="main">
<tr>
      <td class="textlabel">JMSR Admission Number</td>
    </tr>

 <tr >
        <td colspan="2">
            <div class="inputs-wrapper">
                <input 
                  type="text"
            class="admNofield"
           matInput
            placeholder="Search"
            #searchCriteriaInput
            [(ngModel)]="searchCriteria"
            (keyup)="search()"
            [matAutocomplete]="auto"
                />
                <mat-autocomplete #auto="matAutocomplete">
            <mat-option
              *ngFor="let option of options"
              [value]="option.admNo"
              (onSelectionChange)="optionSelected(option, $event)"
            >
              {{ option.admNo }} - {{ option.name }}
            </mat-option>
          </mat-autocomplete>

          <img
            src="../assets/image/searchicon.svg"
            class="icon"
            (click)="search()"
          />

            </div>
        </td>
    </tr>

    <tr>
      <td class="textlabel">Student Name</td>
      <td class="textlabel">Parent Name</td>
      <td class="textlabel">City Name</td>
      <td class="textlabel">Campu Name</td>
    </tr>

 <tr>
  <td>
        <input
          type="text"
          class="inputs bgColor"
          placeholder="Student Name"
          [(ngModel)]="StudentName"
          name="studentName"
          readonly
        />
      </td>
        <td>
        <input
          type="text"
          class="inputs bgColor"
          placeholder="Parent Name"
          [(ngModel)]="selectedStudent.parentName"
          name="parentName"
          readonly
        />
      </td>
      <td>
        <input
          type="text"
          class="inputs bgColor"
          placeholder="City Name"
          [(ngModel)]="selectedStudent.cityName"
          name="cityName"
          readonly
        />
      </td>
      <td>
        <input
          type="text"
          class="inputs bgColor"
          placeholder="Campus Name"
          [(ngModel)]="selectedStudent.campusName"
          name="campsuName"
          readonly
        />
      </td>
    </tr>

    <tr>
      <td class="textlabel">DOB</td>
      <td class="textlabel">Gender</td>
      <td class="textlabel">Rookie Email</td>
       <td class="textlabel"><label for="category">Category</label></td>
    </tr>
<tr>
     <td>
  <input
    type="text"
    class="inputs bgColor"
    placeholder="Dob"
    [value]="selectedStudent.dob | date:'dd-MMM-yyyy'"
    name="dob"
    readonly
  />
</td>


      <td>
        <input
          type="radio"
          id="rbMale"
          name="gender"
          value="M"
          [(ngModel)]="selectedStudent.gender"
          [disabled]="true"
          style="margin-left: 40px"
        />
        <label for="rbMale" style="margin-left: 5px">Male</label>

        <input
          type="radio"
          id="rbFeMale"
          name="gender"
          value="F"
          [(ngModel)]="selectedStudent.gender"
          [disabled]="true"
          style="margin-left: 40px"
        />
        <label for="rbFeMale" style="margin-left: 5px">Female</label>
      </td>

      <td>
        <input
          type="text"
          class="inputs"
          #studentEmailInput
          placeholder="Student Email"
          [(ngModel)]="studentEmail"
          [disabled]="disabledFields"
        />
      </td>
 <td>
        <select
          name="category"
          id="category"
          class="inputs"
          #selectedCategoryIdInput
          [(ngModel)]="selectedCategoryId"
        >
          <option value="0">Select Category</option>
          <option *ngFor="let cat of categoryList" [value]="cat.categoryId">
            {{ cat.categoryName }}
          </option>
        </select>
      </td>
    </tr>

     <tr>
      <td class="textlabel">JEE-MAINS NOT APPLIED</td>
      <td class="textlabel">
        <label for="remarks">Not Applied Remarks</label>
      </td>
      <td class="textlabel"><label for="remarks">Exam Type</label></td>
        <td class="textlabel">Mobile No. (which is registered in mains exam)</td>
    </tr>

<tr>
      <td>
        <input
          type="checkbox"
          #jeeCheck
          (change)="isJeeNotApplied = jeeCheck.checked"
          (change)="clearJeeFields()"
          class="inputs"
          style="margin-right: 10px; width: 24px; height: 24px"
        />
      </td>
      <td>
      <select
        name="remarks"
        id="remarks"
        class="inputs remarks"
        [(ngModel)]="remarks"
        [disabled]="!isJeeNotApplied"
      >
        <option *ngFor="let remark of remarksList" [value]="remark">
          {{ remark }}
        </option>
      </select> 
    </td>

      <td>
  <select class="inputs" [(ngModel)]="examTypes" name="examType">
    <option value="ONLINE">ONLINE</option>
  </select>
</td>
  <td>
        <input
          type="text"
          class="inputs"
          placeholder="Mobile No"
          autocomplete="off"
          maxlength="10"
          #studMobileNoInput
          [(ngModel)]="studMobileNo"
          name="mobileNo"
          inputmode="numeric"
          pattern="[0-9]*"
          (input)="onNumericInput($event, 'studMobileNo')"
          [disabled]="disabledFields"
           [disabled]="jeeFieldsDisabled"

        />
      </td>
    </tr>
 <tr>
      <td class="textlabel">Jee Mains Application No</td>
      <td class="textlabel">Jee Mains Password</td>
      <td class="textlabel">Jee Mains HT-No</td>
        <td class="textlabel">Mains Applied Status</td>
    </tr>
    <tr>
    <td>
        <input
          type="text"
          class="inputs"
          autocomplete="off"
          maxlength="12"
          placeholder="Jee Mains Application No"
          #jeeMainsAppNoInput
          [(ngModel)]="jeeMainsAppNo"
          name="jeeApplicationNo"
          inputmode="numeric"
          pattern="[0-9]*"
          (input)="onNumericInput($event, 'jeeMainsAppNo')"
          [disabled]="disabledFields"
          [disabled]="jeeFieldsDisabled"

        />
      </td>
       <td>
        <input
          type="text"
          class="inputs"
          autocomplete="off"
          placeholder="Jee Mains Password"
          #jeeMainsPasswordInput
          [(ngModel)]="jeeMainsPassword"
          name="jeeMainsPassword"
          [disabled]="disabledFields"
           [disabled]="jeeFieldsDisabled"
        />
      </td>

      <td>
        <input
          type="text"
          class="inputs"
          autocomplete="off"
          maxlength="10"
          #jeeHtnoInput
          placeholder="Jee Mains HT-No."
          [(ngModel)]="jeeMainsHtno"
          name="jeeMainsHtno"
          [disabled]="disabledFields"
        />
      </td>
       <td>
        <input
          type="checkbox"
          class="inputs"
          style="margin-right: 10px; width: 24px; height: 24px"
          [(ngModel)]="selectedStudent.mains1AppliedStatus"
          name="mains1AppliedStatus"
          disabled="true"
        />
      </td>
    </tr>

    <tr>
      <td>
        <hr />
      </td>
      <td>
        <hr />
      </td>
      <td>
        <hr />
      </td>
      <td>
        <hr />
      </td>
    </tr>

     <tr>
      <td colspan="4">
        <div class="buttons">
          <button type="button" class="button1" (click)="clearForm()">
            Clear
          </button>
          <button type="button" class="button2" (click)="submitForm()"
           [disabled]="selectedStudent.passwordStatus?.toUpperCase().startsWith('VALID')">
            Submit
          </button>
        </div>
      </td>
    </tr>

    </table>

     <div class="bothHeadingTable">
    <div class="headingBlock">
      <p class="headingText">Details of records Entered: {{ currentDate }}</p>
    </div>
    <div class="tableBlock">
      <ag-grid-angular
        style="
          width: 95%;
          margin-top: 5px;
          margin-left: 30px;
          margin-bottom: 40px;
          padding: 20px;
        "
        class="ag-theme-alpine"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        domLayout="autoHeight"
      >
      </ag-grid-angular>
    </div>

     <div class="bothHeadingTable">
    <div>
      <p class="headingText">Data Entry Summary</p>
    </div>
    <div class="tableBlock">
      <ag-grid-angular
        style="
          width: 95%;
          margin-top: 17px;
          margin-left: 30px;
          margin-bottom: 20px;
          padding: 20px;
        "
        class="ag-theme-alpine"
        [rowData]="rowDataEntry"
        [columnDefs]="columnDefsEntry"
        [defaultColDef]="defaultColDef"
        domLayout="autoHeight"
    (cellClicked)="onCellClicked($event)"
      >
      </ag-grid-angular>
    </div>
    
  </div>
  </div>

</div>